(function($) {
    'use strict';

/********************************
 ********** plugins**************
 *******************************/

$(document).ready(function() {
    /*
    * Image Stretch module
    */
    var ImageStretcher = {
        getDimensions: function(data) {
            // calculate element coords to fit in mask
            var ratio = data.imageRatio || (data.imageWidth / data.imageHeight),
                slideWidth = data.maskWidth,
                slideHeight = slideWidth / ratio;

            if(slideHeight < data.maskHeight) {
                slideHeight = data.maskHeight;
                slideWidth = slideHeight * ratio;
            }
            return {
                width: slideWidth,
                height: slideHeight,
                top: (data.maskHeight - slideHeight) / 2,
                left: (data.maskWidth - slideWidth) / 2
            };
        },
        getRatio: function(image) {
            if(image.prop('naturalWidth')) {
                return image.prop('naturalWidth') / image.prop('naturalHeight');
            } else {
                var img = new Image();
                img.src = image.prop('src');
                return img.width / img.height;
            }
        },
        imageLoaded: function(image, callback) {
            var self = this;
            var loadHandler = function() {
                callback.call(self);
            };
            if(image.prop('complete')) {
                loadHandler();
            } else {
                image.one('load', loadHandler);
            }
        },
        resizeHandler: function() {
            var self = this;
            jQuery.each(this.imgList, function(index, item) {
                if(item.image.prop('complete')) {
                    self.resizeImage(item.image, item.container);
                }
            });
        },
        resizeImage: function(image, container) {
            this.imageLoaded(image, function() {
                var styles = this.getDimensions({
                    imageRatio: this.getRatio(image),
                    maskWidth: container.width(),
                    maskHeight: container.height()
                });
                image.css({
                    width: styles.width,
                    height: styles.height,
                    marginTop: styles.top,
                    marginLeft: styles.left
                });
            });
        },
        add: function(options) {
            var container = jQuery(options.container ? options.container : window),
                image = typeof options.image === 'string' ? container.find(options.image) : jQuery(options.image);

            // resize image
            this.resizeImage(image, container);

            // add resize handler once if needed
            if(!this.win) {
                this.resizeHandler = jQuery.proxy(this.resizeHandler, this);
                this.imgList = [];
                this.win = jQuery(window);
                this.win.on('resize orientationchange', this.resizeHandler);
            }

            // store item in collection
            this.imgList.push({
                container: container,
                image: image
            });
        }
    };

    // main elements
    var $body = $('body');
    var $win = $(window);

    // remove page load screen on load
    $win.on('load', function() {
        $('#pageLoad')
            .remove();
    });

    // scroll to top  
    $win.scroll(function() {
        if ($(this).scrollTop() > 1000) {
            $('#scroll-to-top').fadeIn();
        } else {
            $('#scroll-to-top').fadeOut();
        }
    });

    $('#scroll-to-top').click(function() {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    // sticky header setup
    $win.scroll(function() {
        if ($(this).scrollTop() > 42) {
            $('#waituk-main-header').addClass("sticky-nav");
        } else {
            $('#waituk-main-header').removeClass("sticky-nav");
        }
    });

    /*
    // initalize parallax js
    $(function() {
        $.stellar({
            horizontalScrolling: false,
            verticalOffset: 0,
            responsive: true
        });
    });*/

    // owl carousel slide set up
    $(".group-slide").owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        items: 1,
        nav: false,
        navText: ['<span class="icon-angle-left"></span>', '<span class="icon-angle-right"></span>'],
        responsive: {
            767: {
                items: 2,
                nav: false,
            },
            991: {
                items: 3,
                nav: true,
                loop: false,
            }
        }
    });

    // Full Width No Gutter Owl Slider
    $("#waituk-owl-slide-1").owlCarousel({
        loop: true,
        margin: 0,
        responsiveClass: true,
        items: 1,
        nav: false,
        dots: true,
        responsive: {
            767: {
                items: 3,
                nav: false,
            },
            991: {
                items: 4,
                nav: false,
                loop: false,
            }
        }
    });

    // Single Owl Slider
    $("#waituk-owl-slide-2").owlCarousel({
        loop: true,
        responsiveClass: true,
        items: 1,
        nav: false,
        navText: ['<span class="icon-angle-left"></span>', '<span class="icon-angle-right"></span>'],
        dots: false,
        autoplay: true,
        responsive: {
            768: {
                nav: false
            },
            992: {
                nav: true,
                loop: false
            }
        }
    });

    // Testimonial Owl Slider
    $("#waituk-owl-slide-3").owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        items: 1,
        nav: false,
        center: true,
        animateOut: 'slideOutDown',
        animateIn: 'flipInX',
        navText: ['<span class="icon-angle-left"></span>', '<span class="icon-angle-right"></span>'],
        smartSpeed: 450,
        responsive: {
            768: {
                items: 3,
                nav: false
            },
            1024: {
                items: 3,
                nav: true
            }
        }
    });

    // Partner Logo Owl Slider
    $("#waituk-owl-slide-4").owlCarousel({
        loop: true,
        margin: 76,
        autoplay: true,
        autoplayTimeout: 5000,
        responsiveClass: true,
        items: 2,
        nav: false,
        responsive: {
            768: {
                items: 3
            },
            1024: {
                items: 6
            }
        }
    });

    /*
    // Image Resize on Window Resize
    $('.bg-stretch').each(function() {
        ImageStretcher.add({
            container: this,
            image: 'img'
        });
    });*/

    $('.bg-stretch').each(function() {
        ImageStretcher.add({
            container: this,
            image: 'img'
        });
    });

    // fancybox plugin setup
    
   
    



    // Progressbar animation  
    $(function() {
        $('.progress .progress-bar').css("width",
            function() {
                return $(this).attr("aria-valuenow") + "%";
            }
        )
    });

    /**
     * search screen plugin
     * @param {object} options
     */
    function Search(options) {
        this.options = $.extend({
            container: null,
            hideOnClickOutside: false,
            menuActiveClass: 'nav-active',
            menuOpener: '.nav-opener',
            menuDrop: '.nav-drop',
            toggleEvent: 'click.search',
            outsideClickEvent: 'click.search touchstart.search pointerdown.search MSPointerDown.search'
        }, options);
        this.initStructure();
        this.attachEvents();
    }

    Search.prototype = {
        initStructure: function() {
            this.page = $('html');
            this.container = $(this.options.container);
            this.opener = this.container.find(this.options.menuOpener);
            this.drop = this.container.find(this.options.menuDrop);
        },
        attachEvents: function() {
            var self = this;
            if (activateResizeHandler) {
                activateResizeHandler();
                activateResizeHandler = null;
            }
            this.outsideClickHandler = function(e) {
                if (self.isOpened()) {
                    var target = $(e.target);
                    if (!target.closest(self.opener)
                        .length && !target.closest(self.drop)
                        .length) {
                        self.hide();
                    }
                }
            };
            this.openerClickHandler = function(e) {
                e.preventDefault();
                self.toggle();
            };
            this.opener.on(this.options.toggleEvent, this.openerClickHandler);
        },
        isOpened: function() {
            return this.container.hasClass(this.options.menuActiveClass);
        },
        show: function() {
            this.container.addClass(this.options.menuActiveClass);
            if (this.options.hideOnClickOutside) {
                this.page.on(this.options.outsideClickEvent,
                    this.outsideClickHandler);
            }
        },
        hide: function() {
            this.container.removeClass(this.options.menuActiveClass);
            if (this.options.hideOnClickOutside) {
                this.page.off(this.options.outsideClickEvent,
                    this.outsideClickHandler);
            }
        },
        toggle: function() {
            if (this.isOpened()) {
                this.hide();
            } else {
                this.show();
            }
        },
        destroy: function() {
            this.container.removeClass(this.options.menuActiveClass);
            this.opener.off(this.options.toggleEvent, this.clickHandler);
            this.page.off(this.options.outsideClickEvent, this.outsideClickHandler);
        }
    };

    var activateResizeHandler = function() {
        var win = $win,
            doc = $('html'),
            resizeClass = 'resize-active',
            flag, timer;
        var removeClassHandler = function() {
            flag = false;
            doc.removeClass(resizeClass);
        };
        var resizeHandler = function() {
            if (!flag) {
                flag = true;
                doc.addClass(resizeClass);
            }
            clearTimeout(timer);
            timer = setTimeout(removeClassHandler, 500);
        };
        win.on('resize orientationchange', resizeHandler);
    };

    $.fn.search = function(options) {
        return this.each(function() {
            var params = $.extend({}, options, {
                    container: this
                }),
                instance = new Search(params);
            $.data(this, 'Search', instance);
        });
    };

    // apply search plugin
    $body.search({
        hideOnClickOutside: true,
        menuActiveClass: 'search-active',
        menuOpener: '.nav-search-link',
        menuDrop: '.holder'
    });

    // side Panel
    $body.search({
        hideOnClickOutside: true,
        menuActiveClass: 'nav-active',
        menuOpener: '.nav-trigger a',
        menuDrop: '.nav-wrap'
    });

    

// Map Holder disable scroll on wheel
    $('.map-holder')
    .click(function(){
            $(this).find('iframe').addClass('clicked')})
    .mouseleave(function(){
            $(this).find('iframe').removeClass('clicked')});

// ripple effect for button
    var $ripple = $('.js-ripple');

    $ripple.on('click.ui.ripple', function(e) {

        var $this = $(this);
        var $offset = $this.parent().offset();
        var $circle = $this.find('.c-ripple__circle');

        var x = e.pageX - $offset.left;
        var y = e.pageY - $offset.top;

        $circle.css({
            top: y + 'px',
            left: x + 'px'
        });

        $this.addClass('is-active');

    });

    $ripple.on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', function() {
        $(this).removeClass('is-active');
    });

    });

}(jQuery));